import type { HTMLAttributes } from "react"

export const AgencyLogo = (props: HTMLAttributes<HTMLDivElement>) => (
  <div className={`flex items-center gap-2 min-w-max ${props.className || ''}`} {...props}>
    <span className="text-lg font-bold text-gray-900 flex-shrink-0">Marketier Agency</span>
  </div>
)
